import { render, staticRenderFns } from "./TifInspeccionesForm.vue?vue&type=template&id=4e9fb40c"
import script from "./TifInspeccionesForm.vue?vue&type=script&lang=js"
export * from "./TifInspeccionesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports